import React from 'react';
import PropTypes from 'prop-types';

import TranslationProvider from '../../providers/TranslationProvider';
import Form from './Form';
import Label from './Label';
import FormErrorInline from './FormErrorInline';
import { EmailInput } from '../Input';
import { SubmitButton } from '../Button';

import './Form.scss';

const EmailForm = (props) => {
  const {
    onSubmit,
    cta,
    error,
    autoFocus,
  } = props;

  return (
    <div className="EmailForm">
      <Form
        name="email_form"
        onSubmit={onSubmit}
        error={error}
      >
        {({
          onChange, errorData, errorKeys, processing,
        }) => (
          <div>
            <Label forInput="email" required>
              <TranslationProvider
                translationKey="onboarding.email_address"
              >
                Email Address
              </TranslationProvider>
            </Label>
            <TranslationProvider
              translationKey="onboarding.email_address"
            >
              <EmailInput
                id="email"
                onChange={onChange}
                errors={errorKeys}
                ariaDescribedby="email_error"
                autoFocus={autoFocus}
              />
            </TranslationProvider>
            {errorData
              && errorData.em_address
              && <FormErrorInline id="email_error">{errorData.em_address}</FormErrorInline>}
            <TranslationProvider
              translationKey="onboarding.continue"
            >
              <SubmitButton
                processing={processing}
                lg
              >
                {cta}
              </SubmitButton>
            </TranslationProvider>
          </div>
        )}
      </Form>
    </div>
  );
};

EmailForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  autoFocus: PropTypes.bool,
  cta: PropTypes.string,
  error: PropTypes.shape({
    serverError: PropTypes.bool,
    msg: PropTypes.string,
    keys: PropTypes.arrayOf(PropTypes.string),
  }),
};

EmailForm.defaultProps = {
  cta: 'Continue',
  autoFocus: false,
  error: {
    serverError: false,
    msg: '',
    keys: [],
  },
};

export default EmailForm;
